import { KeyFeatureT } from '@lambda/apis/src/dynamoDb/types';
import Image from 'next/future/image';

const KeyFeatures = ({ keyFeatures }: { keyFeatures: KeyFeatureT[] }) => {
  const sortedKeyFeatures = keyFeatures.sort((a, b) => a.rank - b.rank);

  return (
    <div className="border-b border-gray-200 bg-[#F6F6F6] text-sm last:border-b-0">
      <div className="grid gap-4 p-4 xs:grid-cols-2 sm:gap-6">
        {sortedKeyFeatures.map((keyFeature) => (
          <div className="flex items-start overflow-hidden">
            <div className="mr-2 h-5 w-5 shrink-0">
              <Image
                src={keyFeature.icon}
                alt={keyFeature.title}
                height={20}
                width={20}
                className="h-full w-full"
              />
            </div>
            <span
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className="two-line-ellipsis"
            >
              {keyFeature.content}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyFeatures;
